import { types as sdkTypes } from './sdkLoader';
import { formatMoney } from './currency';

const { Money } = sdkTypes;

/**
 * Format a basket price snapshot ({ amount, currency }), multiplied by quantity.
 *
 * @param {Object} intl react-intl object
 * @param {Object} price stored price snapshot, see ducks/cart.duck.js
 * @param {number} [quantity=1] how many
 * @returns {string|null} the formatted price, or null without a usable price
 */
export const formatCartPrice = (intl, price, quantity = 1) => {
  if (!price || typeof price.amount !== 'number') {
    return null;
  }
  return formatMoney(intl, new Money(price.amount * quantity, price.currency));
};

/**
 * The running total of a basket, over the items that share its currency.
 *
 * @param {Object} intl react-intl object
 * @param {Array} items basket items
 * @returns {string|null} the formatted total, or null when nothing is priced
 */
export const formatCartSubtotal = (intl, items = []) => {
  const currency = items.find(i => i.price?.currency)?.price?.currency;
  if (!currency) {
    return null;
  }
  const amount = items.reduce(
    (sum, i) =>
      i.price?.currency === currency && typeof i.price?.amount === 'number'
        ? sum + i.price.amount * i.quantity
        : sum,
    0
  );
  return formatMoney(intl, new Money(amount, currency));
};
